import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Navbar from './components/navbar/Navbar';
import Home from './pages/home/Home';
import TentangKami from './pages/tentang-kami/TentangKami';
import Kategori from './pages/kategori/Kategori';
import KategoriProduk from './pages/kategori/KategoriProduk';
import Lokasi from './pages/lokasi/Lokasi';
import KebijakanPrivasi from './pages/kebijakan-privasi/KebijakanPrivasi';

function App() {
  return (
    <BrowserRouter>
      <div className="min-h-screen bg-am-green-50">
        <Navbar />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/tentang-kami" element={<TentangKami />} />
          <Route path="/kebijakan-privasi" element={<KebijakanPrivasi />} />
          <Route path="/kategori" element={<Kategori />} />
          <Route path="/kategori/:slug" element={<KategoriProduk />} />
          <Route path="/lokasi" element={<Lokasi />} />
        </Routes>
      </div>
    </BrowserRouter>
  );
}

export default App;
